import React from "react";
import { useNavigate } from "react-router-dom";
import { AgencyPageLayout, FlexBox } from "@esg/ui";
import { AgencyDateRangePicker } from "@esg/ui/agency/components/filters";
import { UsageTableContainer } from "../branch-detail/containers";
import { BranchItem } from "@esg/business-agency/api/branch";

const UsageDirectoryPage: React.FC = () => {
  const navigate = useNavigate();

  const handleSelectBranch = (branch: BranchItem) => {
    navigate(`/customer/subscriptions/branch/${branch.id}`);
  };

  const scrollableContainerStyle: React.CSSProperties = {
    width: '100%',
    maxHeight: 'calc(100vh - 120px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingBottom: '24px',
    scrollbarWidth: 'none', // Firefox
    msOverflowStyle: 'none',
  };

  return (
    <AgencyPageLayout
      pageTitle="Branch Subscription"
      RightExtraContent={
        <FlexBox
          direction="row"
          gap={12}
          alignItems="center"
          justifyContent="flex-end"
          width="100%"
        >
          <AgencyDateRangePicker />
        </FlexBox>
      }
    >
      <section style={scrollableContainerStyle}>
        <FlexBox direction="column" width="100%">
          <UsageTableContainer onSelectBranch={handleSelectBranch} />
        </FlexBox>
      </section>
    </AgencyPageLayout>
  );
};

export { UsageDirectoryPage };
